// src/shared/auth/Require.tsx
import { Navigate } from 'react-router-dom';
import { useAuth } from './session';

interface Props {
  /** Capability key from the BFF capabilities map */
  ability: string;
  children: React.ReactNode;
}

export default function Require({ ability, children }: Props) {
  const { capabilities, loading, user } = useAuth();
  // Avoid redirect flicker while auth is still loading
  if (loading) return null;
  // If not logged in at all, redirect
  if (!user) return <Navigate to="/" replace />;
  const ok = capabilities.isSuperadmin === true || capabilities[ability] === true;
  return ok ? <>{children}</> : <Navigate to="/" replace />;
}
